import {MouseEvent} from 'react';

import {isKakaoTalk} from '@zzng/common/utils/agent';
import {isDev, isLocal} from '@zzng/common/utils/common';
import {TrackInterface} from '@zzng/common/utils/tiara';

import BackButton from '@/shared/components/BackButton';
import CloseButton from '@/shared/components/CloseButton';
import ComboBoxButton, {ComboBoxButtonProps} from '@/shared/components/ComboBoxButton';
import ConfirmButton, {ConfirmButtonProps} from '@/shared/components/ConfirmButton';
import SettingButton from '@/shared/components/SettingButton';
import ShareButton from '@/shared/components/ShareButton';
import WebviewTestButton from '@/shared/components/WebviewTestButton';
import {isRequiredKakaotalkVersionForDigitalCard} from '@/shared/utils/isRequiredKakaotalkVersion';

export interface HeaderButtonCommonProps {
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void;
  trackEvent: (tiara: TrackInterface) => void;
}

type ButtonProps =
  | ({type: 'CLOSE' | 'BACK' | 'SETTING' | 'SHARE'} & Omit<HeaderButtonCommonProps, 'trackEvent'>)
  | ({type: 'CONFIRM'} & Omit<ConfirmButtonProps, 'trackEvent'>)
  | ({type: 'COMBOBOX'} & Omit<ComboBoxButtonProps, 'trackEvent'>);

export interface HeaderProps {
  /** 헤더 제목 */
  title?: string;
  /** default: 전용웹뷰가 아니거나 톡버전 10.0.5 이하인 경우 true */
  hidden?: boolean;
  /** 추가 시 제목을 a 태그로 대체 */
  onClickTitle?: (e?: MouseEvent<HTMLAnchorElement>) => void;
  /** 헤더 색상 */
  backgroundColor?: string;
  /** default: 닫기 버튼 */
  buttons?: (ButtonProps | false | null | undefined)[];
  /** 티아라 트래킹 */
  trackEvent: (tiara: TrackInterface) => void;
}

const HEADER_BUTTON_MAP: {[type in ButtonProps['type']]: (props: any) => JSX.Element} = {
  CLOSE: CloseButton,
  BACK: BackButton,
  SETTING: SettingButton,
  SHARE: ShareButton,
  CONFIRM: ConfirmButton,
  COMBOBOX: ComboBoxButton
};

const Header = ({
  title,
  hidden = !isKakaoTalk || !isRequiredKakaotalkVersionForDigitalCard,
  onClickTitle,
  backgroundColor,
  buttons = [{type: 'CLOSE'}],
  trackEvent
}: HeaderProps) => {
  if (hidden && !isLocal) return null;

  return (
    <div className="header_idcard" style={{backgroundColor}}>
      {title && (
        <strong className="tit_idcard">
          {onClickTitle ? (
            <a
              href="#"
              className="link_idcard"
              onClick={(e) => {
                e.preventDefault();
                onClickTitle(e);
              }}
            >
              {title}
            </a>
          ) : (
            title
          )}
        </strong>
      )}
      {isDev && <WebviewTestButton />}
      {buttons
        .filter((button): button is ButtonProps => !!button)
        .map(({type, ...props}) => {
          const ButtonComponent = HEADER_BUTTON_MAP[type];
          return <ButtonComponent key={type} trackEvent={trackEvent} {...props} />;
        })}
    </div>
  );
};

export default Header;
